var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemove({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.589 12L18.0421 7.54687C18.2535 7.3359 18.3723 7.04962 18.3726 6.75099C18.3729 6.45237 18.2545 6.16587 18.0435 5.95453C17.8325 5.74319 17.5463 5.62431 17.2476 5.62404C16.949 5.62378 16.6625 5.74215 16.4512 5.95312L11.998 10.4062L7.54492 5.95312C7.33358 5.74178 7.04693 5.62305 6.74805 5.62305C6.44916 5.62305 6.16251 5.74178 5.95117 5.95312C5.73983 6.16447 5.62109 6.45111 5.62109 6.75C5.62109 7.04888 5.73983 7.33553 5.95117 7.54687L10.4043 12L5.95117 16.4531C5.73983 16.6645 5.62109 16.9511 5.62109 17.25C5.62109 17.5489 5.73983 17.8355 5.95117 18.0469C6.16251 18.2582 6.44916 18.3769 6.74805 18.3769C7.04693 18.3769 7.33358 18.2582 7.54492 18.0469L11.998 13.5937L16.4512 18.0469C16.6625 18.2582 16.9492 18.3769 17.248 18.3769C17.5469 18.3769 17.8336 18.2582 18.0449 18.0469C18.2563 17.8355 18.375 17.5489 18.375 17.25C18.375 16.9511 18.2563 16.6645 18.0449 16.4531L13.589 12Z",
    fill: "#39383A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.121aa4c1.svg";
export { ForwardRef as ReactComponent };